import fetch from 'utils/fetch'

export const changeChannelName = params => {
    return fetch({
        url: '/channel/modify_name',
        method: 'POST',
        data: params,
    })
}
